// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"00ce6350","239":"25d80104","453":"a3c1d153","732":"4c9ecac9"}[chunkId] + ".chunk.js";
};